export default "/images/MoreIndustries.webp?c3098d4113d1c20d2a56fb77c83f9a2d";